import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  TREE_LIST: '/dh-datamaint/cwSubject/listSbjCatalogTree',
  PAGE: '/dh-datamaint/courseware/page',
  DELETE: '/dh-datamaint/courseware/batchDelete',
  UPDATE: '/dh-datamaint/courseware/update',
  BATCH_UPDATE: '/dh-datamaint/courseware/batchUpdate',
  DETAIL: '/dh-datamaint/courseware/getById',
  GET_SORT: '/dh-datamaint/courseware/getSort',
  IMPORT_CW: '/dh-datamaint/courseware/importCw',
  SORT_CW: '/dh-datamaint/courseware/sort',
  FOLDER_LIST: '/dh-datamaint/courseware/listImportFolders',
  PAGE_IMPORT: '/dh-datamaint/fileImport/page',
  PAGE_IMPORT_ERROR: '/dh-datamaint/fileImportError/page',
  GET_PREVIEW: '/dh-datamaint/courseware/preview',
  PREVIEW_LANG: '/dh-datamaint/courseware/listCwLang',
  RELATED_SPEC: '/dh-datamaint/specimen/getSpecByVideoId',
  RELATED_SPECS: '/dh-datamaint/specimen/listSpecByVideoId',
  RELATE_SPECS: '/dh-datamaint/specimen/specVideoRelateSpec'
};

const formatCatalog = function (catalogs: any) {
  let catalogNames = '';

  if (catalogs && catalogs.length > 0) {
    catalogs.forEach((item: any) => {
      catalogNames += item.pathZh + '、';
    })

    catalogNames = catalogNames.substring(0, catalogNames.length - 1);
  }

  return catalogNames;
}

class PptModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getTreeList(context: ActionContext<any, any>, payload: any) {
      // const res = await ajax.get(URL.TREE_LIST, { params: payload.data });
      // return [{ id: '', nameZh: '全部', children: res.data.data }];
      return await ajax.get(URL.TREE_LIST, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      // const res = await ajax.get(URL.PAGE, { params: payload.data });
      const res = await ajax.post(URL.PAGE, payload.data,
        { params: { pageNo: payload.data.pageNo, pageSize: payload.data.pageSize } });
      res.data.records.forEach((item: any) => {
        item.pathZh = item.pathZh || '-';
        item.specimenId = item.specimenId || '-';
      })
      return res;
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async BatchUpdate(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.BATCH_UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, payload.data);
    },

    async importCw(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.IMPORT_CW, payload.data);
    },

    async sortCw(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT_CW, payload.data);
    },

    async getFolderList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.FOLDER_LIST, { params: payload.data });
    },

    async getImRecPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT, { params: payload.data });
    },

    async getImErrorPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT_ERROR, { params: payload.data });
    },

    async getPreview(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_PREVIEW, { params: payload.data });
    },

    async getPreviewLang(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PREVIEW_LANG, { params: payload.data });
    },

    async getRelatedSpec(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATED_SPEC, { params: payload.data });
    },

    async getRelatedSpecs(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATED_SPECS, { params: payload.data });
    },

    async relateSpecs(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATE_SPECS, payload.data);
    }
  };
}

export const pptModule = new PptModule();
